import {Vector} from '@teemill/common/classes';

import {defaultControlLayer} from './controlLayers';

export default class OmniControl {
  constructor(opts) {
    if (opts) {
      Object.keys(opts).forEach(i => {
        try {
          this[i] = opts[i];
          // eslint-disable-next-line
        } catch (e) {}
      });
    }
  }

  class = 'objectControls';

  /**
   * @property {function(Vector, Vector)} action The action handler to perform on interacting with the control.
   * The function should accept a from and to Vector, showing where the user has moved their mouse/finger from and to
   */
  action = null;

  /**
   * @property {Vector} placement This is a relative point on the parent object, where (0, 0) is the
   * top left corner, and (1, 1) is the bottom right corner
   */
  placement = new Vector(0, 0);
  position = new Vector(0, 0);
  width = 20;
  height = 20;
  paddingFactor = 1.25;
  mobileScale = 1.5;
  startPosition = false;
  customCursor = 'nw-resize';
  layer = defaultControlLayer;

  getPosition(object) {
    this.position = this.placement.copy();
    this.position.multiply(new Vector(object.width, object.height));

    if (this.offset) {
      this.position = this.position.translate(this.offset.x, this.offset.y);
    }

    return this.position;
  }

  mouseDown() {
    // noop
  }
  mouseUp() {
    // noop
  }
}
